import axios from '@/common/axios-utils';

export default {
  // 接口文档：https://km.sankuai.com/page/1275189285
  queryMeansPackageDeatil(leafKey: String): any {
    return axios.get('/apigw/wisdom/dataPackage/queryByLeafKey', {
      params: {
        productEnName: 'POWER_BANK_DATA_PACKAGE',
        leafKey,
      },
    });
  },
  // 接口文档：https://km.sankuai.com/page/1275189285
  meansPackageReport(event: String, browserSource: String, leafKey: String, id?: Number): any {
    const url = id ? '/apigw/wisdom/dataPackage/browser/record' : '/apigw/wisdom/dataPackage/firstBrowser/record';
    return axios.get(url, {
      params: {
        event,
        browserSource,
        leafKey,
        id,
      },
    });
  },
};
